module.exports = __webpack_public_path__ + "img/login-img.581fd4f8.svg";